// Contador de sugestões abertas no menu (contrato de UI: { companyId }). Atualiza a cada 60s.
import { useRecommendations } from './api'

export default function SuggestionsBadge({ companyId }: { companyId: string }) {
  const q = useRecommendations(companyId, 'open', { refetchInterval: 60_000 })
  const n = q.data?.summary.open ?? 0
  if (!n) return null
  return <span className="count" aria-label={`${n} sugestões abertas`}>{n > 99 ? '99+' : n}</span>
}
